module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"Страница не найдена","title":"Ссылка недействительна или устарела","description":"Ссылка на собеседование не существует или срок её действия истёк. Проверьте ссылку или обратитесь к тому, кто вас пригласил.","action":"Перейти на Huntica"}}')
  delete Component.options._Ctor
}
